import React, { useState, useCallback, useRef } from 'react';
import { Search, MapPin, Calendar, SlidersHorizontal } from 'lucide-react';
import SearchModal from './SearchModal';

const SearchBar = ({ onSearch, filters = {} }) => {
  const [showModal, setShowModal] = useState(false);
  const lockedRef = useRef(false);

  const openModal = useCallback(() => {
    if (lockedRef.current) return;
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    lockedRef.current = true;
    setShowModal(false);
    setTimeout(() => { lockedRef.current = false; }, 300);
  }, []);

  const hasActiveFilters = filters.search || filters.location || filters.dateFrom;

  return (
    <>
      <div className="w-full max-w-2xl mx-auto px-4">
        <button
          onClick={openModal}
          className="search-airbnb w-full flex items-center gap-3 pl-4 pr-2 py-2.5 text-left group"
          data-testid="search-bar-trigger"
        >
          <div className="flex-1 min-w-0">
            {hasActiveFilters ? (
              <div className="flex items-center gap-2 flex-wrap">
                {filters.search && (
                  <span className="text-sm text-gray-700 font-medium truncate">{filters.search}</span>
                )}
                {filters.location && (
                  <span className="flex items-center gap-1 text-xs text-primary bg-primary/5 px-2 py-0.5 rounded-full">
                    <MapPin className="w-3 h-3" />{filters.location}
                  </span>
                )}
                {filters.dateFrom && (
                  <span className="flex items-center gap-1 text-xs text-primary bg-primary/5 px-2 py-0.5 rounded-full">
                    <Calendar className="w-3 h-3" />
                    {new Date(filters.dateFrom + 'T12:00').toLocaleDateString('es-MX', { day: 'numeric', month: 'short' })}
                    {filters.dateTo && ` - ${new Date(filters.dateTo + 'T12:00').toLocaleDateString('es-MX', { day: 'numeric', month: 'short' })}`}
                  </span>
                )}
              </div>
            ) : (
              <span className="text-sm text-gray-300">¿Qué experiencia buscas?</span>
            )}
          </div>
          <div className="flex-shrink-0 p-2 bg-primary rounded-full text-white group-hover:bg-primary-hover transition-colors">
            {hasActiveFilters ? <SlidersHorizontal className="w-4 h-4" /> : <Search className="w-4 h-4" />}
          </div>
        </button>
      </div>

      {showModal && (
        <SearchModal
          open={showModal}
          onClose={closeModal}
          onSearch={(newFilters) => { onSearch(newFilters); closeModal(); }}
          initialFilters={filters}
        />
      )}
    </>
  );
};

export default SearchBar;
